import styled from '@emotion/styled';

import ButtonBase from '../Button';

const Button = styled(ButtonBase)({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  fontSize: 14
});

export default Button;
